import styled from 'styled-components'

export const HospitalQuality = styled.div`
  padding-bottom: 25px;

  > * {
    margin-bottom: 24px;
  }

  .tooltip {
    margin-left: 10px;
  }

  .headline {
    font-weight: bold;
    font-size: 18px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.39;
    letter-spacing: normal;
    color: ${ (props) => props.theme.colors['standard-schwarz'] };
  }
`
